import { HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { environment } from 'src/environments/environment';

export function createTranslateLoader(http: HttpClient) {
  console.info(environment.version)
  return new TranslateHttpLoader(
    http, './assets/i18n/', `.json?version=${environment.version}`,
  );}
